/**
 * Regpath Offer
 * Functionaity for a single offer page
 * 
 * Config Options
 * -- none
 */
define('components/full-page-offer',[
    "jquery",
    "logging",
    "application",
    "utilities" 
], function($, logging, app, utilities) {
    "use strict";

    var _ModuleName = "Full Page Offer Page";
    var _submitLock = false;
    var _config = {
        params: {
            offerId: 'offerId'
        },
        validations: {
            phone: {
                enabled: false,
                field: '',
                message: 'That doesn\'t seem to be a valid number!'
            },
            email: {
                enabled: false,
                field: '',
                message: 'That doesn\'t seem to be a valid email address!'
            },
            address: {
                enabled: false,
                addressField: '',
                cityField: '',
                stateField: '',
                zipField: '',
                message: 'That doesn\'t seem to be a valid address!',
                allowFormCorrection: false
            }
        },
        verifyFormExists: true,
        includeUrlParamsOnProp: [ ],
        skipButtonId: '',
        isMultiStep: false,
        currentStep: 1,
        totalSteps: 1,
        offerId:0,
        enablePlaceholderEmail: false,
        enableFBLeadEvents: false, // Default to false
        registerConversion: true // By default, submit impression to register conversion
    };
    
    var _fieldNames = {
        email: [
            'email',
            'email_address',
            'emailAddress'
        ],
        firstName: [
            'first',
            'first_name',
            'firstName'
        ],
        lastName: [
            'last',
            'last_name',
            'lastName'
        ],
        zip: [
            'zipcode',
            'zip',
            'zip_code',
            'postal_code'
        ],
        phone: [
            'phone',
            'phone_number',
            'phoneNumber',
            'mobile',
            'mobile_phone',
            'mobilePhone'
        ],
        address: [
            'address',
            'street_address',
            'streetAddress',
            'address_1',
        ],
        city: [
            'city',
            'city_name',
            'cityName',
        ],
        state: [
            'state',
            'state_name',
            'stateName',
            'state_code',
            'stateCode',
        ],
        country_code: [
            'country_code',
            'countryCode',
        ]
    }

    var init = function(data) {
        if(app.runningInPathfinder()) {
            logging.debug("Running in Pathfinder");
        }
        
        // allow configuration to disable form verification (used on full offer pages with no form, just a button)
        _config.verifyFormExists = typeof(data.verifyFormExists) !== 'undefined' ? data.verifyFormExists : _config.verifyFormExists;
        // allow ability to disable registration of conversion (impression submission)
        _config.registerConversion = typeof(data.registerConversion) !== 'undefined' ? data.registerConversion : _config.registerConversion;
        // if user defines url parameters to restrict on propagation, store it
        _config.includeUrlParamsOnProp = typeof(data.includeUrlParamsOnProp) !== 'undefined' ? data.includeUrlParamsOnProp : _config.includeUrlParamsOnProp;
        // get skip button id from data object
        _config.skipButtonId = typeof(data.skipButtonId) !== 'undefined' ? data.skipButtonId : _config.skipButtonId;
        // check if we're running with multi step
        _config.isMultiStep = typeof(data.isMultiStep) !== 'undefined' ? data.isMultiStep : _config.isMultiStep;
        // captures step data for multistep
        _config.currentStep = typeof(data.currentStep) !== 'undefined' ? data.currentStep : _config.currentStep;
        _config.totalSteps = typeof (data.totalSteps) !== 'undefined' ? data.totalSteps : _config.totalSteps;
        _config.offerId = (data && data.pathfinder && typeof data.pathfinder.offerId !== 'undefined') ? data.pathfinder.offerId : _config.offerId;
        _config.enablePlaceholderEmail = typeof(data.enablePlaceholderEmail) !== 'undefined' ? data.enablePlaceholderEmail : false;
        _config.country_code = typeof (data.country_code) !== 'undefined' ? data.country_code : _config.country_code;
        _config.enableFBLeadEvents = (data && data.facebook && typeof data.facebook.enableLeadEvents !== 'undefined') ? data.facebook.enableLeadEvents : _config.enableFBLeadEvents;

        // If legacy address validation is defined, enable address validation
        if (typeof(data.validateAddress) !== 'undefined' ? data.validateAddress : false) {
            _config.validations.address.enabled = true;
            logging.debug("Legacy address validation enabled", _ModuleName);
        }

        // If legacy phone validation is defined, enable phone validation
        if (typeof(data.validationPhoneField) !== 'undefined' ? data.validationPhoneField : false) {
            _config.validations.phone.enabled = true;
            _config.validations.phone.field = data.validationPhoneField || '';
            logging.debug("Legacy phone validation enabled", _ModuleName);
        }

        // If validations are defined using the new format, override the default values
        if (data && data.validations) {
            // If phone validations are defined and enabled, override the default values
            if (data.validations.phone && data.validations.phone.enabled) {
                _config.validations.phone.enabled = true;
                _config.validations.phone.field = data.validations.phone.field || '';
                _config.validations.phone.message = data.validations.phone.message || _config.validations.phone.message;
                logging.debug("New phone validation enabled", _ModuleName);
            }

            // If email validations are defined and enabled, override the default values
            if (data.validations.email && data.validations.email.enabled) {
                _config.validations.email.enabled = true;
                _config.validations.email.field = data.validations.email.field || '';
                _config.validations.email.message = data.validations.email.message || _config.validations.email.message;
                logging.debug("New email validation enabled", _ModuleName);
            }

            // If address validations are defined and enabled, override the default values
            if (data.validations.address && data.validations.address.enabled) {
                _config.validations.address.enabled = true;
                _config.validations.address.addressField = data.validations.address.addressField || '';
                _config.validations.address.cityField = data.validations.address.cityField || '';
                _config.validations.address.stateField = data.validations.address.stateField || '';
                _config.validations.address.zipField = data.validations.address.zipField || '';
                _config.validations.address.message = data.validations.address.message || _config.validations.address.message;
                _config.validations.address.allowFormCorrection = data.validations.address.allowFormCorrection || _config.validations.address.allowFormCorrection;
                logging.debug("New address validation enabled", _ModuleName);
            }
        }
    }

    var run = function() {
        if (_config.isMultiStep && !_isFinalStep()) {
            return;
        }

        logging.debug("Enabling Full Page Offer Scripts", _ModuleName);
        
        // Register pending impression on page load (if not running in Pathfinder)
        if (!app.runningInPathfinder() && _config.offerId > 0) {
            app.getGlobalParameters();
            app.submitPendingImpression(_config.offerId);
        }

        var $form = $('form');
               
        // if using new process and form detected
        if ($form.length && _config.verifyFormExists) {
            // Make sure we're only working with the first form
            if ($form.length > 1) {
                $form = $($form[0]);
            }

            // apply any tracked parameters to associated form fields if they exist
            var trackedParameterKeys = app.getTrackedParameterKeys();
            for (var paramIdx = 0; paramIdx < trackedParameterKeys.length; paramIdx++)
            {
                var key = trackedParameterKeys[paramIdx];

                // if form has track1 field, and we have a track1 value, update value of field
                var formField = $form.find(':input[type="hidden"][name="' + key + '"]');
                var fieldVal = app.getTrackedParameterValue(key);
                if (formField.length > 0 && fieldVal) {
                    logging.debug("Setting " + key + " field on form")
                    formField.val(fieldVal);
                }
            }
        
            logging.debug("Storing Method and Action", _ModuleName);
            // hijack the form post so we can do it for them, and then forward them
            // along to the next page on their offer path.
            var method = $form.attr('method'),
                action = $form.attr('action');
            
            logging.debug("Method: " + method, _ModuleName);
            logging.debug("Action: " + action, _ModuleName);

            // if running within Pathfinder, make sure Unbounce doesn't double-submit. we're going to handle it
            if (app.runningInPathfinder()) {
                logging.debug("Running within Pathfinder, ensuring Unbounce doesn't double-submit.", _ModuleName)

                logging.debug("Disabling Default Form Submit", _ModuleName);
                // remove the default form actions, and set up our own.
                $form.unbind();
                $form.submit(function (event) {
                    event.preventDefault();
                    return false;
                });

                logging.debug("Removing form attributes", _ModuleName);
                $form.removeAttr('method').removeAttr('action');
            }

            // huge hack to avoid unbounce error messages in old versions of ie.
            window.alert = function (m) { };
        
            // slightly redefine the form keypress event that unbounce lays on the form. we want
            // the event to bubble up so our handler ultimately catches the event.
            if (window.lp && window.lp.jQuery) {
                // also unbind the submit button 
                window.lp.jQuery('.lp-pom-button').unbind();

                window.lp.jQuery($form).unbind('keypress').keypress(function (e) {
                    if (e.which === 13) {
                        var type = e.target && e.target.nodeName ? e.target.nodeName.toLowerCase() : '';
                        if (type !== 'textarea') {
                            window.lp.jQuery($form).valid();
                        }
                    }
                });
            }

            // check if brand field exists, and if so set it
            var $brandInput = $('input[name=brand]', $form);
            var brandName = app.getBrandName();
            if ($brandInput.length && brandName && $brandInput.val() == '') {
                logging.debug("Setting form field brand to " + brandName, _ModuleName);
                $brandInput.val(brandName);
            }
        
            logging.debug("Updating Click Function of Button", _ModuleName);
            var $submit = $('.lp-pom-button');
            $submit.click(function (e) {
                // prevent event from propagating further
                e.preventDefault();

                // If there's already a lock, bail
                if (_submitLock) {
                    logging.warn("Button has already been clicked, please sit tight", _ModuleName);
                    return;
                }

                // Get lock
                _submitLock = true;
        
                // this is to force the form to re-validate and to make sure we don't
                // just go ahead and post if the form has errors. unbounce implements all
                // of their validation with a different jQuery context, so we need to
                // make sure to use their context, as the validator doesn't  exist on our $ context.
                try {
                    if (window.lp && window.lp.jQuery) {
                        // Grab form element using Unbounces own jQuery instance
                        var $ubForm = window.lp.jQuery('form');
                        // Run validation
                        var validation = $ubForm.validate();
                        // Check if form is valid
                        if ($ubForm.length > 0 && !$ubForm.valid()) {
                            console.error("Form validation failed, form not marked valid.");
                            // Trigger native form validation messages
                            $ubForm[0].reportValidity();
                            _submitLock = false;
                            return false;
                        }
                    } else if ($form && $form.length) {
                        if ($form[0].checkValidity() === false) {
                            console.error("Form validation failed (native), form not marked valid.");
                            // Trigger native form validation messages
                            $form[0].reportValidity();
                            _submitLock = false;
                            return false;
                        }
                    }
                    var formData = _getLeadDataFromForm($form, _fieldNames);
                    // Validate phone number if configured
                    var phoneValidationPromise = Promise.resolve();
                    if (_config.validations.phone.enabled) {
                        var countryCode = formData.country_code || _config.country_code; // Get country code or fallback to config
                        var phoneInput = $form.find('input[name=' + (_config.validations.phone.field || _fieldNames.phone.join('], input[name=')) + ']');
                        // phone input required to validate
                        if (phoneInput.length) {
                            phoneValidationPromise = app.validatePhoneNumber(phoneInput.val(), countryCode) // Pass country code
                                .then(function() {
                                    console.log('Phone validated');
                                })
                                .catch(function (error) {
                                    // Set the custom validation message
                                    window.ub.form.validationMessages[phoneInput[0].name] = {
                                        required: "this field is required",
                                        phone: _config.validations.phone.message
                                    };
                                    // Force the browser to trigger validation error display
                                    phoneInput[0].setCustomValidity(_config.validations.phone.message);                                
                                    // Manually validate the field using Unbounce's validation method
                                    if (window.ub && window.ub.form && typeof window.ub.form.validate === "function") {
                                        window.ub.form.validate(phoneInput[0]);
                                    }
                                    // Optional: Show native validation errors (useful if the form uses HTML5 validation)
                                    // phoneInput[0].reportValidity();
                                    console.log('Phone validation failed', error);
                                    throw new Error('Phone validation failed');
                                });
                        }
                    }

                    // Validate address if configured
                    var addressValidationPromise = Promise.resolve();
                    if (_config.validations.address.enabled) {
                        // address input fields
                        var addressInput = $form.find('input[name=' + (_config.validations.address.addressField || _fieldNames.address.join('], input[name=')) + ']');
                        var cityInput = $form.find('input[name=' + (_config.validations.address.cityField || _fieldNames.city.join('], input[name=')) + ']');
                        var stateInput = $form.find('select[name=' + (_config.validations.address.stateField || _fieldNames.state.join('], select[name=')) + ']');
                        var zipInput = $form.find('input[name=' + (_config.validations.address.zipField || _fieldNames.zip.join('], input[name=')) + ']');

                        // at a minimum, we need an address field to validate
                        if (addressInput.length) {
                            addressValidationPromise = app.validateAddress(addressInput.val(), cityInput.val(), stateInput.val(), zipInput.val())
                                .then(function(response) {
                                    // Address has been validated, and now we'll update the form fields based on the response to ensure accuracy
                                    console.log('Address validated', response);

                                    // if form correction is allowed, we'll update the form fields based on the response to ensure accuracy
                                    if (_config.validations.address.allowFormCorrection) {
                                        // if test address used, we don't need to update any fields
                                        if (addressInput.val().toLowerCase().includes('123 main st')) {
                                            return;
                                        }

                                        // if we have multiple inputs, update them based on the response
                                        if (cityInput.length || stateInput.length || zipInput.length) {
                                            if (addressInput.length && response.address) addressInput.val(response.address);
                                            if (cityInput.length && response.city) cityInput.val(response.city);
                                            if (stateInput.length && response.state) {
                                                // Only update state if it's in the options list
                                                var stateExists = false;
                                                stateInput.find('option').each(function() {
                                                    if ($(this).val() === response.state) {
                                                        stateExists = true;
                                                        return false; // Break loop
                                                    }
                                                });
                                                if (stateExists) {
                                                    stateInput.val(response.state);
                                                }
                                            }
                                            if (zipInput.length && response.zip) zipInput.val(response.zip);
                                        }

                                        // otherwise, combine the data from the response into a single address field
                                        else {
                                            addressInput.val(response.address + ', ' + response.city + ', ' + response.state + ' ' + response.zip);
                                        }
                                    }
                                })
                                .catch(function(error) {
                                    addressInput.attr("autocomplete", "off");
                                    if (cityInput.length) cityInput.attr("autocomplete", "off");
                                    if (stateInput.length) stateInput.attr("autocomplete", "off");
                                    if (zipInput.length) zipInput.attr("autocomplete", "off");
                                    window.ub.form.validationMessages[addressInput[0].name] = {
                                        required: "this field is required",
                                        address: _config.validations.address.message
                                    };
                                    addressInput[0].setCustomValidity(_config.validations.address.message);
                                    if (window.ub && window.ub.form && typeof window.ub.form.validate === "function") {
                                        window.ub.form.validate(addressInput[0]);
                                    }
                                    // addressInput[0].reportValidity();
                                    console.log('Address validation failed', error);
                                    throw new Error('Address validation failed');
                                });
                        }
                    }

                    // Validate email if configured
                    var emailValidationPromise = Promise.resolve();
                    if (_config.validations.email.enabled) {
                        const emailInput = $form.find('input[name=' + (_config.validations.email.field || _fieldNames.email.join('], input[name=')) + ']');
                        // email field required to validate
                        if (emailInput.length) {
                            emailValidationPromise = app.validateEmail(emailInput.val())
                                .then(function() {
                                    console.log('Email validated');
                                })
                                .catch(function(error) {
                                    emailInput.attr("autocomplete", "off");
                                    window.ub.form.validationMessages[emailInput[0].name] = {
                                        required: "this field is required",
                                        email: _config.validations.email.message
                                    };
                                    emailInput[0].setCustomValidity(_config.validations.email.message);
                                    if (window.ub && window.ub.form && typeof window.ub.form.validate === "function") {
                                        window.ub.form.validate(emailInput[0]);
                                    }
                                    // emailInput[0].reportValidity();
                                    console.log('Email validation failed', error);
                                    throw new Error('Email validation failed');
                                });
                        }
                    }

                    // Wait for all validations to complete
                    Promise.all([phoneValidationPromise, addressValidationPromise, emailValidationPromise])
                        .then(function() {
                            console.log('All validations passed');
                            submitForm($form, method, action);
                        })
                        .catch(function() {
                            $form[0].reportValidity();
                            console.log('Validation failed');
                            _submitLock = false;
                        });
                }
                catch (ex) {
                    console.error("Something went wrong checking validation.", _ModuleName);
                    _submitLock = false;
                    return false;
                }
                
                return false;
            });

            // Show Button if it is hidden
            var styles = $submit.attr('style');
            $submit.attr('style', styles + ';display:inline-block !important;');
        } else if (!_config.verifyFormExists) {
            // form not required and we're using v2 process
            var $button = _config.skipButtonId != null && _config.skipButtonId != ''
                ? $('.lp-pom-button:not(#' + _config.skipButtonId + ')')
                : $('.lp-pom-button');
            if($button.length) {
                logging.debug("No form verification required. Configuring button on page", _ModuleName);
                // attach to button on page to allow propogation
                $button.on('click', function(e) {
                    if (_submitLock) {
                        logging.warn("Button has already been clicked, please sit tight", _ModuleName);
                        return;
                    }

                    // Get lock
                    _submitLock = true;

                    e.preventDefault();

                    var $link = $(this);

                    // if we are to include url params on 
                    // propagation, update the defined URL
                    updatePropagationURL($form);
                    
                    var target = $link.attr('target');
                    var href = $link.attr('href');

                    logging.debug("Link target: " + target + " href: " + href, _ModuleName);

                    // Check if clicked element is an anchor tag with target="_blank"
                    // if so, open in new tab/window
                    if (target === '_blank') {
                        if (href && href.length > 0) {
                            window.open(href, '_blank');
                        }
                    }
                    
                    // if running within Pathfinder and we don't want to register conversion, just notify parent complete
                    if (app.runningInPathfinder() && !_config.registerConversion) {
                        logging.debug("button clicked", _ModuleName);
                        logging.debug("Not registering conversion, notifying parent complete", _ModuleName);
                        app.notifyParentComplete();
                        _submitLock = false;
                    }

                    // if running within Pathfinder and we have a lead id, submit impression and notify parent complete
                    else if (app.runningInPathfinder() && app.hasLead()) {
                        logging.debug("button clicked", _ModuleName);
                        app.submitImpression(null, function() {
                            logging.debug("Impression submitted", _ModuleName);
                            app.notifyParentComplete();
                            _submitLock = false;
                        }, app.isStandAloneOffer());
                    } 
                    // if we're running outside of pathfinder or we don't have a lead id, and placeholder email is enabled, we need to create a lead record, followed by an impression record
                    else if (_config.enablePlaceholderEmail) {
                        var runningInPathfinder = app.runningInPathfinder();
                        var runningInAPath = app.runningInAPath();
                        app.submitLead(null, null, null, null, null, function() {
                            logging.debug("Lead submitted", _ModuleName);

                            // if we're not running in pathfinder at all, submit impression
                            if (!runningInPathfinder) {
                                logging.debug("Submitting impression for stand alone offer outside of pathfinder", _ModuleName);
                                app.submitSingleOfferImpression(null, _config.offerId);
                            }

                            // if we are not running in a path, but have an offer passed in, must be stand alone offer within pathfinder so no need to submit impression
                            else if (!runningInAPath) {
                                logging.debug("Not running in a path, but have an offer passed in, must be stand alone offer within pathfinder so no need to submit impression", _ModuleName);
                                app.notifyParentComplete();
                            }

                            // otherwise, submit standard impression
                            else {
                                logging.debug("Submitting standard impression", _ModuleName);
                                app.submitImpression(null, function() {
                                    logging.debug("Impression submitted", _ModuleName);
                                    // if running in pathfinder, notify parent complete
                                    if (runningInPathfinder) {
                                        app.notifyParentComplete();
                                    }
                                    _submitLock = false;
                                }, app.isStandAloneOffer());
                            }
                        }, true);
                    }
                    
                    return false;
                });
            } else {
                logging.debug("No form verification required, but no button found either. Nothing to do here", _ModuleName);
            }
        } else {
            // not using v2 process or form verification required and form doesn't exist
            logging.error("Bad Form. Skipping Component configuration.", _ModuleName);
        }
    }


    function submitForm($form, method, action)
    {
        // if we are to include url params on 
        // propagation, update the defined URL
        updatePropagationURL($form);
        
        try {
            var $confirmAction = $('input[name=openpageonconfirm]', $form);
            if ($confirmAction.length) {
                var url = $confirmAction.attr('value');
                if (typeof url !== undefined) {
                    window.open(url);
                }
            }
        }
        catch (ex) { }

        if(action) {
            action += (action.indexOf('?') < 0 ? '?' : '&') + 'lp-form-submit-method=ajax'
        }
        logging.debug("Submitting Form Data Ourselves to " + action, _ModuleName);
        $.ajax({
            url: action,
            type: method,
            data: $form.serialize(),
            error: function (xhr, status, error) { try { logging.error('error: ' + error, _ModuleName);  } catch (ex) { } },
            success: function (data, status, xhr) { try { logging.debug('success!', _ModuleName); } catch (ex) { } },
            complete: function (xhr, status) 
            { 
                logging.debug("Submission was successful", _ModuleName);
                logging.debug("Submitting Impression Information via Application v2 Processes", _ModuleName);
                if (app.runningInPathfinder()) {
                    var standAloneOffer = utilities.getParameter(document.URL, 'stand_alone_offer');
                    //check here if standAlone offer
                    if (standAloneOffer) {
                        logging.debug("Submitting Lead via Application v2 Processes for stand alone offer", _ModuleName);
                        var formData = _getLeadDataFromForm($form, _fieldNames);
                        app.submitLead(formData.firstName, formData.lastName, formData.email, formData.zip, formData.phone, function () {
                            logging.debug("Notify parent of impression");
                            app.submitImpression($form, (function () {
                                logging.debug("Notifying parent complete with impression data");
                                app.notifyParentCompleteWithImpression($form);
                            }), true);
                        }, _config.enablePlaceholderEmail);
                    } else {
                        app.submitImpression($form, function () {
                            app.notifyParentComplete();
                        }, false);
                    }
                } else {
                    // Check if Facebook Lead events are enabled and the pixel is detected
                    if (_config.enableFBLeadEvents && window.fbq) {
                        logging.debug("Facebook Lead events enabled. Firing Lead event.", _ModuleName);

                        // Generate a unique event ID
                        var fbEventID = Math.random().toString(36).slice(2, 11);
                        if (window.fbEventID) {
                            logging.debug("Using fbEventID from GTM");
                            fbEventID = window.fbEventID;
                        }

                        // Extract lead data from the form
                        var leadData = _getLeadDataFromForm($form, _fieldNames);

                        // Fire the Lead event using the Facebook pixel
                        fbq('track', 'Lead', {
                            fn: leadData.firstName,
                            ln: leadData.lastName,
                            zp: leadData.zip,
                            em: leadData.email,
                            slug: window.location.pathname, 
                        }, {
                            eventID: fbEventID,
                        });

                        // Submit lead data to the Pathfinder endpoint for server-side Facebook CAPI
                        var event = {
                            eventName: 'Lead',
                            eventId: fbEventID,
                            externalId: fbEventID,
                            slug: window.location.pathname, 
                            userFirstName: leadData.firstName,
                            userLastName: leadData.lastName,
                            userZip: leadData.zip,
                            userEmail: leadData.email,
                        };

                        app.createFacebookEvent(event, window.location.href)
                            .then(function () {
                                logging.debug("Facebook Lead event submitted to Pathfinder endpoint.", _ModuleName);
                                proceedToRedirect($form, _config, _fieldNames, _submitLock);
                            })
                            .catch(function (error) {
                                logging.error("Failed to submit Facebook Lead event to Pathfinder endpoint: " + error, _ModuleName);
                                proceedToRedirect($form, _config, _fieldNames, _submitLock);
                            });
                    } else {
                        proceedToRedirect($form, _config, _fieldNames, _submitLock);
                    }
                }
            }
        });
    }

    function proceedToRedirect($form, _config, _fieldNames, _submitLock) {
        var offerId = _config.offerId;
        if (offerId > 0) {
            logging.debug("Submitting lead and impression outside Pathfinder", _ModuleName);
            var formData = _getLeadDataFromForm($form, _fieldNames);
            app.submitLead(formData.firstName, formData.lastName, formData.email, formData.zip, formData.phone, function () {
                logging.debug("Lead submission successful. Now registering offer impression.", _ModuleName);
                app.submitSingleOfferImpression($form, offerId, function () {
                    logging.debug("Impression submission successful. Now redirecting to form URL.", _ModuleName);
                    window.location.href = window.ub.form.url;
                });
            }, _config.enablePlaceholderEmail);
        } else {
            _submitLock = false;
            logging.debug('Not running within Pathfinder, so we\'re done here.');

            if (window.ub.form.includeFormData) {
                var formFields = $form.serializeArray();

                // Filter out fields that start with 'xx' or 'page'
                var filteredFields = formFields.filter(function(field) {
                    return !field.name.startsWith('xx') && !field.name.startsWith('page');
                });
                var formData = $.param(filteredFields);
                var separator = window.ub.form.url.indexOf('?') > -1 ? '&' : '?';
                logging.debug("Redirecting to URL with form data: " + window.ub.form.url + separator + formData, _ModuleName);
                window.location.href = window.ub.form.url + separator + formData;
            } else {
                logging.debug("Redirecting to URL: " + window.ub.form.url, _ModuleName);
                window.location.href = window.ub.form.url;
            }
        }
    }

    function _getLeadDataFromForm($form, fieldNames) {
        return {
            firstName: _getFieldValue($form, fieldNames.firstName),
            lastName: _getFieldValue($form, fieldNames.lastName),
            email: _getFieldValue($form, fieldNames.email),
            zip: _getFieldValue($form, fieldNames.zip),
            address: _getFieldValue($form, fieldNames.address),
            city: _getFieldValue($form, fieldNames.city),
            state: _getFieldValue($form, fieldNames.state),
            phone: _getFieldValue($form, fieldNames.phone),
            country_code: _getFieldValue($form, fieldNames.country_code)
        };
    }

    var updatePropagationURL = function($form) {
        // ensure we have the necessary unbounce form object available
        if (window.ub && window.ub.form) {
            // if we are to include url params on propagation, update the defined URL
            if (window.ub.form.url.length > 0 && _config.includeUrlParamsOnProp.length > 0) {
                // disable automatic inclusion of all fields
                window.ub.form.includeFormData = false;
                // get form field data based on our configuration
                var params = [];
                _config.includeUrlParamsOnProp.forEach(function(fieldName) {
                    var field = $('#' + fieldName, $form);
                    if (field && field.length) {
                        var encoded = encodeURI(field.val());
                        params.push(fieldName + '=' + encoded);
                    }                        
                });
                // update propagation url with our new parameters
                window.ub.form.url += (window.ub.form.url.indexOf('?') > -1 ? '&' : '?') + params.join('&');
            }
        }
    }
    
    var _getFieldValue = function ($form, name) {
        if (typeof name == 'string') {
            var field = $form.find("input[name='" + name + "'], select[name='" + name + "']");
            if (field && field.length > 0) {
                // account for radio buttons and checkboxes by filtering for actual selection
                if (field[0].type === "radio" || field[0].type === "checkbox") {
                    field = $form.find("input[name='" + name + "']:checked");
                }

                return field.length ? field[0].value : '';
            }
        }

        if (Array.isArray(name)) {
            for (var i = 0; i < name.length; i++) {
                var field = $form.find("input[name='" + name[i] + "'], select[name='" + name[i] + "']");
                if (field.length) {
                    return field[0].value;
                }
            }
        }

        return '';
    }

    var _isFinalStep = function() {
        return _config.currentStep === _config.totalSteps;
    }

    return {
        init: init,
        run: run
    }
});
